import { fetchApi } from "./api"
import { mockClientService } from "@/mocks/mock-service"
import type { GapClientConfig, CreateGapClientRequest, UpdateGapClientRequest } from "@/types/gap-client"

// Check if mock mode is enabled
const USE_MOCKS = import.meta.env.VITE_USE_MOCKS === "true"

// Real API service
const realClientService = {
  async getAll(): Promise<GapClientConfig[]> {
    return fetchApi<GapClientConfig[]>("/api/v1/config/gap/clients")
  },

  async getById(clientId: string): Promise<GapClientConfig> {
    return fetchApi<GapClientConfig>(`/api/v1/config/gap/clients/${clientId}`)
  },

  async create(data: CreateGapClientRequest): Promise<GapClientConfig> {
    return fetchApi<GapClientConfig>("/api/v1/config/gap/clients", {
      method: "POST",
      body: JSON.stringify(data),
    })
  },

  async update(clientId: string, data: UpdateGapClientRequest): Promise<GapClientConfig> {
    // Only include adminPassword if it's provided (non-empty)
    const updatePayload: UpdateGapClientRequest = { ...data }
    if (!updatePayload.adminPassword) {
      delete updatePayload.adminPassword
    }

    return fetchApi<GapClientConfig>(`/api/v1/config/gap/clients/${clientId}`, {
      method: "PUT",
      body: JSON.stringify(updatePayload),
    })
  },

  async delete(clientId: string): Promise<void> {
    return fetchApi<void>(`/api/v1/config/gap/clients/${clientId}`, {
      method: "DELETE",
    })
  },
}

// Select service based on environment
export const clientService = USE_MOCKS ? mockClientService : realClientService

// Log which mode is active (helpful for debugging)
if (import.meta.env.DEV) {
  console.log(`🔧 Client Service: ${USE_MOCKS ? "MOCK MODE" : "API MODE"}`)
}
